import React from 'react';
interface ProgressRingProps {
  pct: number;
  threshold?: number;
  size?: number;
  stroke?: number;
  label?: string;
}
export function ProgressRing({
  pct,
  threshold,
  size = 64,
  stroke = 7,
  label
}: ProgressRingProps) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - Math.min(100, Math.max(0, pct)) / 100);
  const reached = threshold !== undefined && pct >= threshold;
  return <div className="relative shrink-0" style={{
    width: size,
    height: size
  }} role="img" aria-label={label ?? `${pct} %`} data-id="element-437" data-mp="34ts1z768axjl">
      <svg width={size} height={size} className="-rotate-90" data-id="element-438" data-mp="39vr4keu59qfh">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#EFE1CA" strokeWidth={stroke} data-id="element-439" data-mp="3dwb0xg6w8q0k" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={reached ? '#2F8256' : '#C24E28'} strokeWidth={stroke} strokeLinecap="round" strokeDasharray={c} strokeDashoffset={offset} style={{
        transition: 'stroke-dashoffset 260ms cubic-bezier(0.23, 1, 0.32, 1)'
      }} data-id="element-440" data-mp="3it9p7i3vm2qu" />
      </svg>
      <span className="absolute inset-0 grid place-items-center font-display font-semibold tabular-nums" style={{
      fontSize: size < 48 ? 11 : size > 90 ? 24 : 15
    }} data-id="element-441" data-mp="14hou48o6im0u">
        {pct}%
      </span>
    </div>;
}